import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from "src/app/icon/icon.module";

type ChipType = 'active' | 'inactive' | 'enabled' | 'disabled' | 'transferred' | 'not-transferred' | 'sent' | 'pending' | 'failed' | 'license-cancelled';

const CHIP_CONFIG: Record<ChipType, { label: string; icon: string; class: string }> = {
  active: {
    label: 'active',
    icon: 'circle-check',
    class: 'bg-emerald-50 border-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:border-emerald-800 dark:text-emerald-300'
  },
  inactive: {
    label: 'inactive',
    icon: 'circle-off',
    class: 'bg-slate-200 border-slate-300 text-slate-700 dark:bg-slate-700/50 dark:border-slate-500 dark:text-slate-200'
  },
  enabled: {
    label: 'enabled',
    icon: 'circle-check',
    class: 'bg-emerald-50 border-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:border-emerald-800 dark:text-emerald-300'
  },
  disabled: {
    label: 'disabled',
    icon: 'circle-off',
    class: 'bg-slate-200 border-slate-300 text-slate-700 dark:bg-slate-700/50 dark:border-slate-500 dark:text-slate-200'
  },
  transferred: {
    label: 'transferred',
    icon: 'circle-check',
    class: 'bg-emerald-50 border-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:border-emerald-800 dark:text-emerald-300'
  },
  'not-transferred': {
    label: 'not transferred',
    icon: 'clock',
    class: 'bg-amber-50 border-amber-200 text-amber-700 dark:bg-amber-950/40 dark:border-amber-800 dark:text-amber-300'
  },
  // Email statuses keep the stored value (SENT, PENDING, FAILED) as the label
  sent: {
    label: 'SENT',
    icon: 'circle-check',
    class: 'bg-emerald-50 border-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:border-emerald-800 dark:text-emerald-300'
  },
  pending: {
    label: 'PENDING',
    icon: 'clock',
    class: 'bg-amber-50 border-amber-200 text-amber-700 dark:bg-amber-950/40 dark:border-amber-800 dark:text-amber-300'
  },
  failed: {
    label: 'FAILED',
    icon: 'circle-x',
    class: 'bg-red-50 border-red-100 text-red-700 dark:bg-red-950/40 dark:border-red-800 dark:text-red-300'
  },
  'license-cancelled': {
    label: 'license cancelled',
    icon: 'calendar-off',
    class: 'bg-red-50 border-red-100 text-red-700 dark:bg-red-950/40 dark:border-red-800 dark:text-red-300'
  }
};

@Component({
  selector: 'app-chip',
  imports: [TranslateModule, IconModule],
  templateUrl: './chip.component.html'
})
export class ChipComponent {
  @Input() type: ChipType;

  get config() {
    return CHIP_CONFIG[this.type];
  }
}
